<template>
    <div style="width: 100%">
        <component
            :is="isSubcategoryPage ? 'SubcategoryPage' : 'ListPage'"
            :data="data"
            :category="category"
            @search="onSearch"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes } from 'http-status-codes';

import headMixin from '@/mixins/head.mixin.js';
import ListPage from '@/components/clinical-researches/ListPage';
import SubcategoryPage from '@/components/clinical-researches/SubcategoryPage';

export default {
    components: {
        ListPage,
        SubcategoryPage
    },

    mixins: [headMixin],

    async asyncData({
        store: { dispatch, getters },
        params: { slug: idOrSlug },
        error
    }) {
        const SUBCATEGORY_PAGE_TYPE =
            getters['clinicalResearchCategories/SUBCATEGORY_PAGE_TYPE'];

        let data = null;

        try {
            const category = await dispatch(
                'clinicalResearchCategories/show',
                idOrSlug
            );

            const isSubcategoryPage = category.type === SUBCATEGORY_PAGE_TYPE;

            data = await dispatch(
                `clinicalResearchCategories/get${
                    isSubcategoryPage ? 'Subcategories' : 'ResearchList'
                }`,
                idOrSlug
            );

            return {
                data,
                category,
                isSubcategoryPage,
                meta: category.meta
            };
        } catch (err) {
            if (err.response?.status !== StatusCodes.INTERNAL_SERVER_ERROR) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        headTitle() {
            return this.category.title;
        }
    },

    methods: {
        ...mapActions({
            searchArticles: 'articles/search'
        }),

        async onSearch(searchingText) {
            this.data.articles = await this.searchArticles({
                searchingText,
                researchListId: this.data.id
            });
        }
    }
};
</script>
